const loyaltyStamps = {
    stampsSettings: "Stamps settings",
    stampsRequiredToRedeem: "Stamps required to redeem",
    allMenu: "All menu",
    stampGifts: "Stamp gifts",
    specificCategories: "Specific categories",
    specificItems: "Specific items",
    dragAndDropItems: "Drag & drop items from the menu on the right",
    dropItemsHere: "Drop items here",
    eligibleItemsCategories: "What items/categories eligible to earn a stamp?",
    stampImages: "Stamp images",
    optional: "Optional",
    stampImagesDescription: "This is the default appearance for active and inactive stamps. You can also upload your own images. Images should be at least 4KB and at most 1MB.",
    giftImage: "Gift image",
    giftImageDescription: "This is the default appearance for gift stamp. You can also upload your own image. Image should be at least 4KB and at most 1MB.",
    resetToDefault: "Reset to default",
    save: "Save Changes",
    saving: "Saving...",
    fileTooSmall: "Image must be at least 4KB",
    fileTooLarge: "Image must be at most 1MB",
    imageProcessingError: "Failed to process image. Please try again.",
    failedToSaveConfiguration: "Failed to save configuration",
    configurationSavedSuccessfully: "Configuration saved successfully",
    stamps: "Stamps",
    gifts: "Gifts",
    stampsExpireIn: "Stamps will expire in",
    giftsExpireIn: "Gifts will expire in",
    days: "Days",
    hours: "Hours",
    months: "Months",
    stampsRequiredError: "Stamps required to redeem must be between 1 and 9",
    allowMultipleStampsPerOrder: "Allow multiple stamps per order",
    allowMultipleStampsPerOrderTooltip: "Enable to allow customers to earn multiple stamps for these items in a single transaction.",
    branchNotificationsSettings: "Branch Notifications Settings",
    selectBranchToCustomize: "Select a branch to customize notifications",
    branchList: "Branch List",
    notificationMessageEn: "Notification's message (En)",
    notificationMessageAr: "Notification's message (Ar)",
    notificationMessageEnPlaceholder: "Enter notification message in English",
    notificationMessageArPlaceholder: "Enter notification message in Arabic",
    notificationMessageUpdates: "Notification Message Updates",
    updatesRemainingToday: "{{count}} updates remaining today",
    notificationUpdatesDelayNote: "Updates may take up to 3 hours to be reflected in the app.",
};

export default loyaltyStamps;
